// Hook - synchroniczne przeliczenie analytics dla klienta (3-5s loading)
// GET /api/ui/trader/insights/refresh/{clientId}
//
// Uzywany jako mutation-like przez `mutate()` (refetch on demand),
// nie auto-refetchuje sie. Po wykonaniu warto invalidate-owac `trader-insights-client`.

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetRefreshClientAnalyticsResponse } from 'api/types/traderInsights';

export interface IRefreshClientAnalyticsVariables {
  clientId: number;
  onlyFields?: string;
}

const getRefreshClientAnalytics = ({
  clientId,
  onlyFields,
}: IRefreshClientAnalyticsVariables): Promise<IGetRefreshClientAnalyticsResponse> =>
  axios.get(`/trader/insights/refresh/${clientId}`, {
    params: onlyFields ? { only_fields: onlyFields } : undefined,
  });

export const useGetRefreshClientAnalytics = (
  options?: UseMutationOptions<
    IGetRefreshClientAnalyticsResponse,
    IError,
    IRefreshClientAnalyticsVariables
  >
) =>
  useMutation(
    (variables: IRefreshClientAnalyticsVariables) => getRefreshClientAnalytics(variables),
    options
  );
